const PageMinHeight = {
  account: {
    'birthday-savings': 'mh-150',
    'rate-review': 'mh-150',
    'buy-it-again': 'mh-150',
    profile: 'mh-500',
    'add-gift-card': 'mh-500',
    'points-history': 'mh-500',
    'add-new-address': 'mh-500',
    'edit-address': 'mh-500',
    'order-details': 'mh-1000',
    'place-rewards': 'mh-1000',
    'my-preference': 'mh-1000',
    'place-perks': 'mh-1000',
    'edit-credit-card': 'mh-CreditCard',
    'add-credit-card': 'mh-CreditCard',
    wallet: 'mh-400',
    orders: 'mh-400',
    payment: 'mh-400',
    favorites: 'mh-400',
    'store-locator': 'mh-400',
    'address-book': 'mh-150',
    account: 'mh-1300',
  },
  otherPages: {
    'customer-help': 'mh-customerHelp',
    'gift-card-balance': 'mh-500',
    tracking: 'mh-600',
    accessibility: 'mh-1000',
    customerservice: 'mh-1100',
    'childrens-place-coupons': 'mh-childrensPlaceCoupons',
    'content/giftcard': 'mh-contentGiftCard',
    'content/recall-information': 'mh-150',
    'content/supply-chain': 'mh-contentSupplyChain',
    donotsell: 'mh-doNotSale',
    'content/buy-online': 'mh-contentBuyOnline',
    'extra-points': 'mh-1300',
    bag: 'mh-300',
    'login-checkout': 'mh-loginCheckout',
    login: 'mh-300',
    'change-password': 'mh-300',
    register: 'mh-500',
    content: 'mh-contentPage',
    'track-order': 'mh-500',
    'gift-options': 'mh-600',
  },
};

export default PageMinHeight;
